export const COMPANY = {
  name: "Executive Print Group",
  addressLines: ["#21, 3rd Cross,", "Sudhamanagar,", "Bangalore – 560027, India"],
  phone: "98451 66280",
  ceo: "H. V. Santosh",
  teamCount: 30,
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1503694978374-8a2fa686963a?auto=format&fit=crop&w=1920&q=80",
  roller: "https://images.pexels.com/photos/19837529/pexels-photo-19837529.jpeg?auto=compress&cs=tinysrgb&w=1200",
  brochure: "https://images.unsplash.com/photo-1614036634955-ae5e90f9b9eb?auto=format&fit=crop&w=1200&q=80",
  catalogue: "https://images.pexels.com/photos/36682054/pexels-photo-36682054.jpeg?auto=compress&cs=tinysrgb&w=1200",
  swatches: "https://images.unsplash.com/photo-1565562141896-9e2423ad19b5?auto=format&fit=crop&w=1200&q=80",
  paper: "https://images.unsplash.com/photo-1631270314738-e6f6827f8d9f?auto=format&fit=crop&w=1200&q=80",
  inspection: "https://images.pexels.com/photos/36376452/pexels-photo-36376452.jpeg?auto=compress&cs=tinysrgb&w=1200",
  operator: "https://images.pexels.com/photos/10960792/pexels-photo-10960792.jpeg?auto=compress&cs=tinysrgb&w=1200",
  workshop: "https://images.pexels.com/photos/4140941/pexels-photo-4140941.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const CLIENTS = [
  "Bosch Power Tools",
  "Titan Company Limited",
  "Mead Johnson",
  "Timken India Limited",
  "Coats India Limited",
  "Bosch Automotive Market",
  "Bosch Diesel Systems",
];

export const SERVICES = [
  {
    num: "01",
    name: "Offset Printing",
    desc: "Commercial offset printing on advanced Heidelberg multi-colour presses, delivering sharp, consistent results across every sheet.",
    image: IMAGES.roller,
  },
  {
    num: "02",
    name: "Brochure Printing",
    desc: "Corporate brochures produced with meticulous attention to colour, fold and finish — built to represent your brand with precision.",
    image: IMAGES.brochure,
  },
  {
    num: "03",
    name: "Catalogue Printing",
    desc: "Multi-page catalogues printed with precise registration and uniform quality from the first page to the last.",
    image: IMAGES.catalogue,
  },
  {
    num: "04",
    name: "Wobbler Printing",
    desc: "Point-of-sale wobblers, precisely printed and die-punched to stand out in demanding retail environments.",
    image: IMAGES.swatches,
  },
  {
    num: "05",
    name: "Dangler Printing",
    desc: "Promotional danglers finished with gelatin loop pinning, ready for immediate retail display.",
    image: IMAGES.paper,
  },
  {
    num: "06",
    name: "Streamer Printing",
    desc: "Promotional streamers printed with crisp detail and dependable colour for high-visibility display.",
    image: IMAGES.workshop,
  },
];

export const PRODUCTION_LINE = [
  {
    num: "01",
    name: "Heidelberg Multi-Colour Offset",
    type: "Primary Press",
    desc: "Advanced multi-colour Heidelberg offset machines form the core of our print production.",
  },
  {
    num: "02",
    name: "Single-Colour Offset",
    type: "Secondary Press",
    desc: "Dedicated single-colour offset machines support efficient monochrome production.",
  },
  {
    num: "03",
    name: "Automatic Cutting",
    type: "Post-Press",
    desc: "Automatic cutting delivers clean, accurate edges across every batch.",
  },
  {
    num: "04",
    name: "Folding",
    type: "Post-Press",
    desc: "Precision folding for brochures, catalogues and multi-panel collateral.",
  },
  {
    num: "05",
    name: "Die Punching",
    type: "Finishing",
    desc: "Die punching shapes wobblers, danglers and custom-cut print collateral.",
  },
  {
    num: "06",
    name: "Laminating",
    type: "Finishing",
    desc: "Lamination protects and elevates the surface of every finished piece.",
  },
  {
    num: "07",
    name: "Gelatin Loop Pinning",
    type: "Specialised Finishing",
    desc: "Gelatin loop pinning prepares danglers and display material for retail use.",
  },
  {
    num: "08",
    name: "Quality Control",
    type: "Final Stage",
    desc: "Every print undergoes rigorous quality checks monitored by trained professionals.",
  },
];

export const QUALITY_HIGHLIGHTS = [
  {
    num: "01",
    title: "Process Control",
    desc: "From design to dispatch, every stage of production follows a controlled, detail-driven process.",
  },
  {
    num: "02",
    title: "Colour Accuracy",
    desc: "Multi-colour work is monitored closely for accurate, repeatable colour on every run.",
  },
  {
    num: "03",
    title: "Consistent Quality",
    desc: "Every print undergoes rigorous quality checks monitored by trained professionals.",
  },
  {
    num: "04",
    title: "Timely Execution",
    desc: "Disciplined production planning ensures dependable, on-time delivery.",
  },
  {
    num: "05",
    title: "Client Collaboration",
    desc: "Every project begins with understanding the client's vision — and ends when expectations are exceeded.",
  },
];

export const INSPECTION_STAGES = [
  "Pre-Press Review",
  "Plate & Setup Check",
  "Colour Verification",
  "Registration Check",
  "Final Inspection",
];

export const COMMITMENTS = [
  "Customer-first approach",
  "Ethical business practices",
  "Timely service",
  "Transparent communication",
  "Long-term relationships",
];

export const PROJECT_TYPES = [
  "Offset Printing",
  "Brochure Printing",
  "Catalogue Printing",
  "Wobbler Printing",
  "Dangler Printing",
  "Streamer Printing",
  "Other",
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/capabilities", label: "Capabilities" },
  { to: "/quality", label: "Quality" },
  { to: "/clients", label: "Clients" },
  { to: "/contact", label: "Contact" },
];
